<div class="pageFont">
    <div style="padding-top: 35px; padding-bottom: 35px;">
        <div [innerHTML] = confirmationText>
        </div>
    </div>
    <div style="display: flex; margin: 0 auto; justify-content: center; text-align: center;">
        <button class="White btn btnRadius btnBorder btnBackgroundColor btnPadding" (click)="acceptChanges()">{{v('confirm')}}</button>
        <button class="White btn btnRadius btnBorder btnBackgroundColor btnPadding btnMargin" (click)="decideLater()">{{v('later')}}</button>
        <button class="White btn btnRadius btnBorder btnBackgroundColor btnPadding btnMargin" (click)="rejectChanges()">{{v('decline')}}</button>
    </div>
</div>